import { NodeModel } from "../_model/NodeModel";
import { DecorationBomb } from "./decorationBomb";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Bomb extends NodeModel {
    constructor(location = { x: 0, y: 0}) {
        super("Bomb");

        this.type = new Types().Bomb;

        this.x = location.x;
        this.y = location.y;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 90;
        this.width = 120;
        this.operationSelected = "";
        this.srcImg = require("@/assets/Fluxogramas/bomba.png");
        this.data = [new Properties({...this })];
        this.jokerCaption = [];

        this.decorate = async function(callback) {
            this.decorator = new DecorationBomb();
            await this.decorator.init(this, callback);
        };

        this.clone = () => {
            let cloned = new Bomb();
            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.readOnly = this.readOnly
            cloned.decorator = null;
            cloned.expressionVisible = this.expressionVisible
            cloned.jokerCaption = this.jokerCaption
            cloned.data = this.data.map(d => d.clone());

            return cloned;
        };

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.jokerCaption = node.jokerCaption
            this.data = node.data.map((d) => new Properties({...d }));
        };

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }
            
            this.expressionVisible = node.expressionVisible;
            this.jokerCaption = node.jokerCaption;
        };
    }
}

export { Bomb };